
















































// Importing components
import BaseCard from '@/ui/BaseCard.vue';
import BasePagination from '@/base/BasePagination.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
import TheTableUsers from '@/components/users/TheTableUsers.vue';
import LayoutApp from '@/layputs/LayoutApp.vue';
// Importing function
import {getUsers} from '@/ts/users/get-users';

export default {
    name: 'PageUsers',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableUsers,
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            items: Array(),
            search_param: String(),
        };
    },
    methods: {
        // Switching between pages
        switchPage(page) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setCurrentPage', page);
            getUsers().then(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        onSubmit() {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setQueryParam', this.search_param);
            getUsers().then(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Потребители',
        }];
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');
        this.$store.dispatch('setCurrentPage', 1);
        this.$store.dispatch('setLastPage', 1);
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getUsers().then(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
